import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { useMemo } from 'react'
import { ChartContainer } from 'src/components/chart/container'
import { Colors, Shapes } from 'src/components/theme'

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`
const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
type Segment = {
  y: number
  color: string
  name: string
}
type DonutChartProps = {
  height?: number
  data: Array<Segment>
  title?: string | number
  subtitle?: string
  titleFontSize?: number
}
const CHART_PADDING = Shapes.spacing[5]
export const DonutChart = (props: DonutChartProps) => {
  const { data, height, title, subtitle, titleFontSize = 24 } = props

  const size = useMemo(() => {
    if (height) {
      return height - CHART_PADDING
    }
    return '100%'
  }, [data])

  const innerSize = useMemo(() => {
    // leave at least 80px for the outer circle
    if (height && height - CHART_PADDING > 160) {
      return `${height - CHART_PADDING - 80}px`
    }
    return '80%'
  }, [height])

  const options: Highcharts.Options = useMemo(() => {
    const sorted = data.sort((a, b) => b.y - a.y)
    const options = {
      chart: {
        type: 'pie',
        animation: false,
      },
      title: undefined,
      plotOptions: {
        series: {
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              enabled: false,
            },
          },
        },
        pie: {
          shadow: false,
          borderWidth: 0,
          slicedOffset: 0,
          borderRadius: 0,
        },
      },
      tooltip: {
        enabled: false,
      },
      series: [
        {
          data: sorted,
          size: size ? size : '100%',
          // make inner circle so that outer is circle is 24px
          innerSize: innerSize,
          showInLegend: false,
          dataLabels: {
            enabled: false,
          },
        },
      ],
    }
    return options as any
  }, [data])
  return (
    <Wrapper>
      <ChartContainer height={height} options={options} />
      <Content>
        {title && (
          <Typography fontSize={titleFontSize} color={Colors.neutral950} lineHeight={1.3}>
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography variant="header3s" color={Colors.neutral500}>
            {subtitle}
          </Typography>
        )}
      </Content>
    </Wrapper>
  )
}
